/**
 * @desc 财务画像-概述-财务造假
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import { Table, Tabs } from 'antd';
import { PAGE_SIZE } from '../../../../constants/common';
import { addDataIndex } from '../../../../utils/util';
import GroupBox from '../../../common/groupBox/GroupBox';
import EllipsisAndTooltip from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';
import { commonRequest } from '../../common/commons';
import ScorePane from '../../common/scorePane/ScorePane';
import IndexPane from './common/IndexPane';
import Motive from './fraud/Motive';
import { queryOverviewFraud } from '../../../../services/financialPicture/overview';
const TabPane = Tabs.TabPane;

export default class FinancialFraud extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            baseData: {},
            indexData: [],
            indexValueData: [],
            pathData: [],
            loading: true
        };
    }

    componentDidMount() {
        this.getFraudData();
    }

    getFraudData = () => {
        queryOverviewFraud(commonRequest()).then(data => {
            data = data || {};
            let { fraudScoreTypeList, financeFraudAbnormalIndexValueDto, fraudAbnormalIndexList, analysisList, ...financeData } = data;

            this.setState({
                baseData: {
                    ...financeData,
                    radarData: fraudScoreTypeList || []
                },
                indexData: addDataIndex(fraudAbnormalIndexList),
                indexValueData: financeFraudAbnormalIndexValueDto || [],
                pathData: addDataIndex(analysisList),
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    getPathColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 1
        }, {
            title: '造假路径',
            dataIndex: 'key',
            width: 5,
            render: (v) => <EllipsisAndTooltip text={v} />
        }, {
            title: '业务解释',
            dataIndex: 'value',
            width: 10,
            render: (v) => <EllipsisAndTooltip text={v} />
        }];
    };

    render() {
        const {
            loading,
            baseData,
            indexData,
            indexValueData,
            pathData
        } = this.state;

        const { explain, fraudTotalScore, radarData } = baseData;

        return (
            <GroupBox title="财务舞弊" explain={explain}>
                <Tabs defaultActiveKey="score" animated={false} className="line-tabs margin">
                    <TabPane tab="财务舞弊评分" key="score">
                        <ScorePane loading={loading} score={fraudTotalScore} radarData={radarData}/>
                    </TabPane>
                    <TabPane tab="财务舞弊动机与表象" key="motive">
                        <Motive />
                    </TabPane>
                    <TabPane tab="财务舞弊异常指标" key="index">
                        <IndexPane loading={loading} indexData={indexData} indexValueData={indexValueData} type="fraud"/>
                    </TabPane>
                    <TabPane tab="财务舞弊路径" key="path">
                        <Table
                            bordered
                            lodading={true}
                            dataSource={pathData}
                            columns={this.getPathColumns()}
                            pagination={pathData.length > PAGE_SIZE}
                        />
                    </TabPane>
                </Tabs>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/overview/subComponents/FinancialFraud.jsx